"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useControlGroup = void 0;
var react_1 = require("react");
var ControlsContext_1 = require("./ControlsContext");
var useControlGroup = function () {
    var context = (0, react_1.useContext)(ControlsContext_1.ControlsContext);
    if (context === undefined) {
        throw new Error("useControlGroup must be used within a ControlsContextGroup.Provider");
    }
    return context;
};
exports.useControlGroup = useControlGroup;
